module.exports = __webpack_public_path__ + "img/flavor_kiwi.cd559d1e.png";